module.exports = __webpack_public_path__ + "e2a44b20f625f414f58007a74a04db1e.svg";